export class State {
    constructor(_value) {
        this._value = _value;
        this.subs = new Set();
    }
    get value() {
        return this._value;
    }
    subscribe(sub) {
        if (!this.subs.has(sub)) {
            this.subs.add(sub);
            sub(this._value);
        }
        return () => this.subs.delete(sub);
    }
    set(value) {
        this._value = value;
        this.subs.forEach(sub => sub(this._value));
    }
    toJSON() {
        return this._value;
    }
}
